/*
Ashraf 01/11/2022 2699710829 redux slice to handle client audit actions
Ashraf 01/13/2022 2699710829 Added download functionality actions.
Ravi 06/22/2023 2699710829 fixed submit issue
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {submissionEnd} from '../CommonActions/commonActions';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  fieldListStatus: null,
  groupData: {},
  fieldListPostStatus: null,
  addSuccessMsg: null,
  ClientAuditListPrintStatus: null,
  allCodeAndDescription: [],
  dropDownData: {},
  auditFieldListStatus: null,
  clientListData: {},
  unMappedClientsData: {},
  auditListData: {},
  configurationUrl: '',
  dockey: '',
};
const slice = createSlice({
  name: 'auditFieldList',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.fieldListStatus = null;
    },

    resettingData: (state, action) => {
      state.baseCategoryData = [];
      state.joinFieldCodeData = [];
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
      state.fieldListStatus = null;
      state.fieldListData = {};
      state.fieldListPostStatus = null;
    },
    fetchClientCodeData: (state, action) => {
      state.unMappedClientsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchAllAuditData: (state, action) => {
      state.auditListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetStatus: (state) => {
      state.fieldListStatus = null;
      state.addGlobalFieldListStatus = null;
      state.isLoading = false;
      state.auditFieldListStatus = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.fieldListStatus = null;
      state.fieldListData = {};
      state.fieldListPostStatus = null;
      state.ClientAuditListPrintStatus = null;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    resetCode: (state, action) => {
      state.joinFieldCodeData = state.joinFieldCodeData.filter((item) => item !== action.payload);
    },
    postAuditListData: (state, action) => {
      state.auditFieldListStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getClientListData: (state, action) => {
      state.clientListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    setClientAuditListPrintData: (state, action) => {
      state.isLoading = false;
      state.ClientAuditListPrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getAllCodeAndDescription: (state, action) => {
      state.allCodeAndDescription = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetGlobalFieldListData: (state, action) => {
      state.globalFieldListData = {};
    },
    resetDownloadMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.DataRepoPrintStatus = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetStatusMsg: (state, action) => {
      state.auditFieldListStatus = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  fetchStart,
  fetchError,
  fetchSuccess,
  resetMsg,
  resetStatus,
  postGroupData,
  postGlobalFieldAddData,
  resetGlobalFieldStatus,
  postAuditListData,
  fetchAddSuccess,
  resettingData,
  resetCode,
  setFieldListData,
  setClientAuditListPrintData,
  resettingGroupData,
  getAllCodeAndDescription,
  resetFieldListData,
  getClientListData,
  resetGlobalFieldListData,
  resetDownloadMessage,
  fetchDropDownData,
  fetchClientCodeData,
  fetchAllAuditData,
  resetStatusMsg,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
} = slice.actions;


export const fetchClientAuditListData = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`debtor-audit/get/clientaudit/${clientNumber}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getClientListData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const printClientAuditList = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`debtor-audit/print/clientaudit`, data)
      .then((data) => {
        if (data && data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postPrintClientAuditList({dockey: data?.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const postPrintClientAuditList = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`debtor-audit/generateclientfieldlistprinturl`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setClientAuditListPrintData(postRuleGroupData));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postRuleGroupData));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const getClientAuditCodeData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`debtor-audit/get/clients/`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchClientCodeData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getAllAuditListData = (tabType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`globalfield/find/all/fieldlistcodeanddescription/${tabType}`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchAllAuditData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postClientAuditList = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`debtor-audit/save/clientaudit`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 500) {
          dispatch(fetchError(data?.data?.error));
        } else if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data?.status && data?.status === 200 && data?.response?.userMetrix) {
          dispatch(postGlobalFieldAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data?.status && data?.status === 200) {
          dispatch(postAuditListData(data));
          // dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const getForeignKeyFieldData = (payload, dataCallBack) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/search/all/listofcategory`, payload)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dataCallBack(data.response.resultObject[0]);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllCodeAndDescription = (data) => {
  return (dispatch) => {
    httpGet(`globalfield/find/all/fieldlistcodeanddescription`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCodeAndDescription(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const ResetAddGlobalFieldList = () => {
  return (dispatch) => {
    dispatch(resetGlobalFieldStatus());
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch(resettingData());
  };
};
export const resetFieldsData = () => {
  return (dispatch) => {
    dispatch(resetFieldListData());
  };
};
export const resetGroupData = () => {
  return (dispatch) => {
    dispatch(resettingGroupData());
  };
};

export const resetAddFieldListStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const resetGlobalFieldList = () => {
  return (dispatch) => {
    dispatch(resetGlobalFieldListData());
  };
};

export const resetDownload = () => {
  return (dispatch) => {
    dispatch(resetDownloadMessage());
  };
};
export const resetStatusAndMessage = () => {
  return (dispatch) => {
    dispatch(resetStatusMsg());
  };
};
